export const sizeFont = [10, 11, 12, 13, 14, 16, 18, 20, 24, 30];

export const sizeFontReals = [
  "10px",
  "11px",
  "12px",
  "13px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "30px",
];

export const families = [
  "Futura PT Cond",
  "Helvetica",
  "Address Sans Pro",
  "Franklin Gothic",
  "Barlow",
  "Proxima Nova",
  "DIN Condensed",
  "DIN Std",
];